<template>
	<section class="new-official-agency-description">
		<div class="new-official-agency-description__inner new-layout-container">
			<h2>{{content.title}}</h2>
			<p>{{content.firstParagraph(eventName)}}</p>
			<p>{{content.secondParagraph}}</p>
		</div>
	</section>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	props: {
		eventName: {
			type: String,
			required: true,
		},
	},
	computed: {
		content() {
			return translate(this.$store.state.language).eventPage.officialAgency;
		},
	},
};
</script>

<style scoped lang="scss">
.new-official-agency-description {
	box-sizing: border-box;
	min-height: 360px;
	padding: 28px 0 42px;
	background: #65abc5;
	color: #ffffff;
}

.new-official-agency-description h2 {
	margin: 0 0 18px;
	font-size: 25px;
	font-weight: 900;
	line-height: 29px;
}

.new-official-agency-description p {
	margin: 0 0 22px;
	font-size: 18px;
	font-weight: 400;
	line-height: 25px;
}

.new-official-agency-description p:last-child {
	margin-bottom: 0;
}

@media (max-width: 900px) {
	.new-official-agency-description {
		min-height: 0;
		padding: 30px 0 36px;
	}

	.new-official-agency-description h2,
	.new-official-agency-description p {
		font-size: 18px;
		line-height: 25px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/event/OfficialAgencyDescription.vue